import { useEffect, useState } from "react"
import { getRegimenFiscals, getUsoCFDIs, getFormasPago, getPaises } from '../helpers/getFacturaCats';


export const useFetchFacturaCats = () => {

    const [state, setState] = useState({
        dataCDFIs: [],
        dataRFs: [],
        dataFPs: [],
        dataPaises: [],
        loading: true
    });

    useEffect(() => {

        getUsoCFDIs()
        .then( cdfis => {

            getRegimenFiscals()
            .then( rfs => {

                getFormasPago()
                .then( fps => {

                    getPaises()
                    .then( paises => {

                        setState({
                            dataCDFIs: cdfis,
                            dataRFs: rfs,
                            dataFPs: fps,
                            dataPaises: paises,
                            loading: false
                        });                        
                    })

                })

            })
        })

    }, []);
    
    return state;
}
